import PropTypes from 'prop-types'
import DataViewer from '@utils/DataViewer'
import Seo from '@components/Seo'
import { StringParam, useQueryParam } from 'use-query-params'
import MiniSearch from 'minisearch'
import { useEffect } from 'react'
import { useState } from 'react'
import { client } from '@lib/sanity.server'
import { expandPortableText } from '@lib/queries'
import RichText from '@components/RichText'
import resolveLink from '@utils/resolveLink'
import SanityLink from '@components/SanityLink'
import Link from 'next/link'
import styled from '@emotion/styled'
import Section from '@components/Section'
import { mobile } from '@styles/global'
const Template = ({ data }) => {
	const documents = data?.documents

	const [searchParam, setSearchParam] = useQueryParam('q', StringParam)
	const [results, setResults] = useState()
	const [searchItems, setSearchItems] = useState()
	
	useEffect(() => {
		async function fetchData() {
			// You can await here
			// const response = await client.fetch(prepareQuery())
			// add ...response.capabilities to the array below once we've made the parent query

			const shortTextToString = (text) => {
				if (text) {
					return text.map(block => block.children.map(child => child.text).join(' ')).join(' ')
				} else {
					return ''
				}
			}			

			const pages = documents?.pages || []

			const articles = documents?.articles || []

			const stories = documents?.stories || []

			setSearchItems([...pages, ...articles, ...stories])

		}
		fetchData()
	}, [])

	let miniSearch = new MiniSearch({
		fields: ['title', 'section', 'header', 'introduction', 'metaDescription', 'headline', 'headerText'], // fields to index for full-text search
		storeFields: ['title', '_key', '_type', 'id', 'slug', 'section', 'metaDescription', 'headline', 'headerText'], // fields to return with search results
		searchOptions: {
			boost: { title: 2 },
			fuzzy: 0.2
		}
	})

	useEffect(() => {
		if(!miniSearch) return
		if(searchItems?.length > 0) {
			miniSearch?.addAll(searchItems)
		}
	}, [searchItems, miniSearch])

	useEffect(() => {
		if(searchParam?.length > 0) {
			const searchResults = miniSearch?.search(searchParam, { prefix: true })
			setResults(searchResults)
			// console.log(searchResults)
		} else {
			setResults(searchItems)
		}
	}, [searchParam, searchItems])

	return (
		<>
			<Seo 
				title="Search"
			/>
			<Results>
				{searchParam && results?.length > 0 &&
					<Tally>{results?.length} result{results?.length > 1 ? 's' : ''}</Tally>
				}
				{results?.map(item => (
					<Result key={item?.id} href={resolveLink(item)} item={item}>
						<Heading>{item?.title}</Heading>
						{item?.metaDescription && 
							<p>{item?.metaDescription}</p>
						}
					</Result>
				))}
				{searchParam && results?.length === 0 &&
					<Empty>Sorry, no results.</Empty>
				}
			</Results>
			<DataViewer data={results} name='results' />
		</>
	)
}

const Result = styled(Link)`
	display: block;
	grid-column: span 12;
	box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.05);
	padding: var(--l);
	max-width: 1053px;
	margin: 0 auto var(--m);
	box-sizing: border-box;
	width: 100%;
	p {
		max-width: 800px;
	}
`

const Heading = styled.h4`
	margin-bottom: var(--xxs);
`

const Results = styled(Section)`
	min-height: 100vh;
	margin-top: 200px;
	margin-bottom: var(--xxl);
	${mobile}{
		margin-top: 250px;
	}
`

const Tally = styled.h5`
	grid-column: span 12;
	margin: 0 auto var(--m);
	max-width: 1053px;
	width: 100%;
`

const Empty = styled.h5`
	grid-column: span 12;
	text-align: center;
	
`

Template.propTypes = {
	data: PropTypes.object,
}

export default Template

